import { render, staticRenderFns } from "./WNewsDropdown.vue?vue&type=template&id=022ca100&"
import script from "./WNewsDropdown.vue?vue&type=script&lang=ts&"
export * from "./WNewsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./WNewsDropdown.vue?vue&type=style&index=0&id=022ca100&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports